import React from 'react';
import img_editors_choice from './assets/ex22_editors_choice.webp';
import img_featured from './assets/ex22_featured_in.png';
import recommended_by from './assets/recommended_by.png';

const footerItems = {
  featured: <img src={img_featured} style={{width: '334px', height: '85px'}} />,
  editors_choice: <img src={img_editors_choice} style={{width: '197px', paddingBottom: '20px'}} />,
  recommended_by: <img src={recommended_by} style={{width: '342px', height: '65px', paddingBottom: '20px'}} />,
  disclaimer: (
    <div
      style={{
        backgroundColor: 'var(--color-gray6)',
        padding: 16,
        borderRadius: 8,
        zIndex: 1000,
        fontSize: 12,
        lineHeight: 1.5,
        color: 'var(--color-black)',
      }}
    >
      Based on real RISE user data, we’ll estimate how much your sleep and energy can improve with your custom plan.
      While results aren’t guaranteed, 80% of users saw improvements in their first week.
    </div>
  ),
};

type ItemId = keyof typeof footerItems;

type Props = {
  currentScreenIndex: number;
  config: {screenIndex: number; itemId: ItemId}[];
};

const Container = ({children}: {children: React.ReactNode}) => (
  <div
    style={{
      position: 'fixed',
      bottom: 0,
      left: 16,
      right: 16,
      maxWidth: 360,
      margin: '0 auto',
      padding: 16,
      borderRadius: 8,
      zIndex: 1000,
      fontSize: 12,
      lineHeight: 1.5,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    {children}
  </div>
);

export function SocialProofFooterItem({currentScreenIndex, config}: Props) {
  const itemId = config?.find(item => item.screenIndex === currentScreenIndex)?.itemId;
  if (!itemId) {
    return null;
  }

  const FooterItem = footerItems[itemId];

  return <Container>{FooterItem}</Container>;
}
